/**
 * BusinessObjective Validation Schemas
 */

import { z } from 'zod';
import { nameField, optionalBoundedText, requiredIdField } from './shared';

export const createBusinessObjectiveSchema = z.object({
  name: nameField(200, 'Name is required', 'Name must be 200 characters or less'),
  description: optionalBoundedText(2000),
  objectiveType: z.enum(
    ['strategic', 'operational', 'financial', 'customer', 'innovation', 'compliance'],
    {
      message: 'Objective type is required',
    }
  ),
  priority: z.enum(['critical', 'high', 'medium', 'low']).optional(),
  status: z
    .enum(['draft', 'approved', 'in-progress', 'achieved', 'missed', 'cancelled'])
    .optional(),
  startDate: z.string().optional(),
  targetDate: z.string().optional(),
  timeHorizon: z.enum(['short-term', 'medium-term', 'long-term']).optional(),
  successCriteria: optionalBoundedText(2000),
  kpiStatement: optionalBoundedText(2000),
  ownerId: requiredIdField('Owner is required'),
  owningBusinessUnitId: z.string().optional(),
  sponsorId: z.string().optional(),
  tags: z.array(z.string().min(1)).optional().default([]),
  notes: optionalBoundedText(5000),
});

export type CreateBusinessObjectiveFormData = z.infer<typeof createBusinessObjectiveSchema>;
